import * as XLSX from "xlsx"

export function handleDownload(data, columns, title) {
    const worksheetData = [
        columns.map((col) => col.title), // Header row
        ...data.value.map((row) => columns.map((col) => row[col.value] ?? "")),
    ]

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, "UsageCount")

    const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" })
    const blob = new Blob([wbout], { type: "application/octet-stream" })

    const url = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url

    const today = new Date().toISOString().split("T")[0]
    a.download = `${title}-${today}.xlsx`

    a.click()
    URL.revokeObjectURL(url)
}
